const FormContainer = ({children}) => {
  return (
    <div style={{margin: '0 auto', maxWidth: '600px'}}>
      {children}
    </div>
  )
}

export default FormContainer
